<template>
  <div>
    <div id="middle-detail-wrap">
      <PlanInfo :listInfo="curRow" @close="closePanel" v-if="curTab === 'plan'" />
      <MaterialInfo :listInfo="curRow" @close="closePanel" v-if="curTab === 'material'" />
    </div>
    <TissueInfo :listInfo="curRow" @close="closePanel" v-if="curTab === 'tissue'" />
    <CameraPicture
      @refresh="closePanel"
      v-if="curTab === 'camera'"
      :deviceCode="curRow.code"
      :plid="curRow.pIid"
      class="w-970px h-500px"
    />
  </div>
</template>
<script>
import bus from './bus'

const PlanInfo = () => {
  return import('./PlanInfo')
}
const TissueInfo = () => {
  return import('./TissueInfo')
}
const CameraPicture = () => {
  return import('../components/smartSecurity/cameraPicture')
}
const MaterialInfo = () => {
  return import('./Material')
}
export default {
  name: 'emergency-disposal-middlecar',
  components: { TissueInfo, PlanInfo, CameraPicture, MaterialInfo },
  props: {},
  data() {
    return {
      curRow: {},
      curTab: '',
    }
  },
  created() {
    bus.$on('translate', (data) => {
      this.curTab = data.type || ''
      this.curRow = data.row || {}
    })
  },
  methods: {
    closePanel() {
      this.curTab = ''
    },
  },
}
</script>
<style lang="scss" scoped>
#middle-detail-wrap {
  ::v-deep .el-textarea__inner {
    border: 1px solid !important;
    border-color: var(--cockpitInputBorderColor) !important;
    background-color: var(--cockpitInputBgColor) !important;
    color: var(--cockpitInputFontColor) !important;

    &:hover {
      border-color: var(--cockpitInputHoverBorderColor) !important;
    }
  }
  ::v-deep {
    .el-input__inner,
    .el-textarea__inner {
      border: none !important;
      padding: 0 !important;
    }
    .el-textarea__inner {
      position: relative !important;
      top: 11px !important;
    }
    .el-input__prefix {
      display: none !important;
    }
  }
}
</style>
